import { PermissionsScope } from '../../policies/policy.model'
import { SelectionData } from '../../../models/util.model'

export const CUSTOMER_FRAGMENT = 'customer'
export const CUSTOMER_SCOPE: PermissionsScope = 'customers'

export const CUSTOMER_TABS: SelectionData<CustomerTab>[] = [
  {
    value: 'general',
    label: 'General',
  },
  {
    value: 'addresses',
    label: 'Shipping addresses',
  },
]

export type CustomerTab = 'general' | 'addresses'
